import React from 'react';
import { Box, IconButton } from '@mui/material';
import Trash from '@mds/icons/Trash';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { NameCellRenderer } from '../../../../../ui/admin/AdminList';
import {
    convertToDate,
    formatDisplayDate,
} from '../../../../../../utils/date.utils';
import { ChannelGroup } from '../../../../../../shared/types';

type GetChannelGroupColumnDefsArgs = {
    apiName: string;
    onDeleteClick: (group: ChannelGroup) => void;
};

type ChannelGroupRendererProps = ICellRendererParams & {
    data: ChannelGroup;
    value?: string;
};

const getChannelGroupColumnDefs = ({
    apiName,
    onDeleteClick,
}: GetChannelGroupColumnDefsArgs): ColDef[] => [
    {
        colId: 'group-drag-col',
        headerName: '',
        width: 40,
        rowDrag: true,
        cellRenderer: 'agRowDragCellRenderer',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
    },
    {
        colId: 'group-name-col',
        headerName: 'Group name',
        field: 'name',
        cellRenderer: (props: ChannelGroupRendererProps) => (
            <NameCellRenderer {...props} apiName={apiName} />
        ),
        width: 260,
        menuTabs: [],
    },
    {
        colId: 'group-description-col',
        headerName: 'Description',
        field: 'description',
        width: 420,
        menuTabs: [],
    },
    {
        colId: 'group-channels-col',
        headerName: 'Channels',
        field: 'channelsCount',
        width: 160,
        menuTabs: [],
    },
    {
        colId: 'group-created-col',
        headerName: 'Created',
        field: 'createdAt',
        cellRenderer: (props: ChannelGroupRendererProps) => (
            <>{formatDisplayDate(convertToDate(props.value), true)}</>
        ),
        width: 260,
        menuTabs: [],
    },
    {
        colId: 'group-delete-col',
        headerName: '',
        field: '_id',
        width: 80,
        sortable: false,
        suppressHeaderMenuButton: true,
        menuTabs: [],
        cellRenderer: (props: ChannelGroupRendererProps) => (
            <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <IconButton
                    id={`delete-channel-group-${props.data._id}`}
                    aria-label="delete channel group"
                    color="error"
                    sx={{ p: 0.5 }}
                    onClick={() => onDeleteClick(props.data as ChannelGroup)}
                >
                    <Trash />
                </IconButton>
            </Box>
        ),
    },
];

export default getChannelGroupColumnDefs;
